import script from "./client-model.vue?vue&type=script&setup=true&lang=js"
export * from "./client-model.vue?vue&type=script&setup=true&lang=js"

import "./client-model.vue?vue&type=style&index=0&id=72018197&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72018197"]])

export default __exports__